import ShoplineTracker from './shopline/index.js'
import CyberbizTracker from './cyberbiz/index.js'
import NineyiTraceService from './nineyi/index.js'
import LogHelper from '../utils/logHelper.js'
import Utils from '../utils/utils.js'
const utilsHelper = new Utils()
export default class EventTracker {
    constructor(container_id, config, is_debug, storage_key){
        this.container_id = container_id
        this.config = config
        this.is_debug = is_debug
        this.storage_key = storage_key
        this.logHelper = new LogHelper(config.LOG_LEVEL, config.LOG_ENDPOINT, is_debug, container_id)
        this.retry_time = 5
    }
    async run (){

        try {

            console.log('optimize99_feature_t_run: ', this.container_id)

            this.logHelper.send({
                "level": 'info',
                "stage": 'view',
                "request_payload": JSON.parse(localStorage.getItem(this.storage_key))
            })

            // 判斷是哪個網店平台
            let platform = utilsHelper.checkPlatform()
            let traceService = null
            switch (platform) {
                case 'shopline':
                    console.log('t:','shopline')
                    traceService = new ShoplineTracker(
                        this.container_id,
                        this.config,
                        this.is_debug,
                        this.storage_key
                    )
                    if (!window.app) {
                        for (let idx = 0 ; idx <= this.retry_time; idx++) {
                            console.log('shopline', 'not_exist')
                            await utilsHelper.sleep(2000);
                            if (!window.app) {
                                continue
                            }
                            traceService.run()
                            break
                        }
                    }
                    else {
                        console.log('shopline', 'exist')
                        traceService.run()
                    }
                    break;
                case 'cyberbiz':
                    console.log('t:','cyberbiz')
                    traceService = new CyberbizTracker(
                        this.container_id,
                        this.config,
                        this.is_debug,
                        this.storage_key
                    )
                    traceService.run()
                    break;
                case '91app':
                    console.log('t:','91app')
                    traceService = new NineyiTraceService(
                        this.container_id,
                        this.config,
                        this.is_debug,
                        this.storage_key
                    )
                    setTimeout(function(){
                        traceService.run()
                    }, 1000)
                    break;
                default:
                    console.log('t:','unknown')
                    break
            }

        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_run_error',
                'error_trace': {
                  error_message: error.message,
                  error_stack: error.stack
                }
            })
        }
        
    }

    abTestCallback(views){
        let platform = utilsHelper.checkPlatform()
        try {
            console.log('optimize99_feature_t_abTestCallback_', views)
            
            let traceService = null
            switch (platform) {
                case 'shopline':
                    console.log('shopline')
                    traceService = new ShoplineTracker(
                        this.container_id,
                        this.config,
                        this.is_debug,
                        this.storage_key
                    )
                    break;
                case 'cyberbiz':
                    console.log('cyberbiz')
                    traceService = new CyberbizTracker(
                        this.container_id,
                        this.config,
                        this.is_debug,
                        this.storage_key
                    )
                    break;
                case '91app':
                    console.log('91app')
                    traceService = new NineyiTraceService(
                        this.container_id,
                        this.config,
                        this.is_debug,
                        this.storage_key
                    )
                    break;
                default:
                    break
            }

            if (traceService) {
                traceService.abTestCallBack(views)
            }
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_abTestCallback_error_' + platform,
                'error_trace': {
                  error_message: error.message,
                  error_stack: error.stack
                }
            })
            // throw Error(error)
        }
    }
}